import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import BaseModalComponent, {
  StyledBaseModal,
  StyledBaseModalContent,
  StyledBaseModalHeader,
} from '../../BaseModal.component';
import SpinnerComponent from '../../../Spinner.component';
import { useAppSelector } from '../../../../hooks/useAppSelector.hook';
import { getEventMeta } from '../../../../redux/Event/Event.slice';
import ButtonComponent from '../../../Button.component';
import { EventMetaGroup } from '../../../../redux/Event/Event.type';
import { uniqueId } from 'lodash';
import { useAppDispatch } from '../../../../hooks/useAppDispatcher.hook';
import { getEventMetaThunk } from '../../../../redux/Event/Event.thunk';
import { StyledIconButton } from '../../../IconButton.component';
import { useModalManager } from '../../../../hooks/ModalManager.hook';
import RecordEditModalComponent from './RecordEditModal.component';
import { Person } from '../../../../redux/Candidate/Candidate.type';

export interface RecordPreNewProps
  extends React.AllHTMLAttributes<HTMLDivElement> {
  mergePerson?: Person;
  isUnmergeDuplicate?: boolean;
  isNewCandidate?: boolean;
  onCandidateAdded?: () => void;
}

const StyledRecordPreNewStackGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const StyledRecordPreNewStackV = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const StyledRecordPreNewStack = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 240px);
  gap: 10px;
  padding-bottom: 28px;
`;
const StyledRecordPreNew = styled.div`
  ${StyledBaseModal} {
    position: relative;
    animation-name: ${({ theme }) => theme.animations.slide.modalRB};

    ${StyledBaseModalHeader} {
      ${StyledIconButton} {
        position: absolute;
        bottom: 10px;
        right: 10px;
        z-index: 10;
      }
    }
  }

  ${StyledBaseModalContent} {
    padding: 10px 55px 25px 15px;
  }
`;

const RecordPreNewModalComponent = ({
  mergePerson,
  isUnmergeDuplicate,
  isNewCandidate,
  onCandidateAdded,
}: RecordPreNewProps) => {
  const dispatch = useAppDispatch();
  const { openModal } = useModalManager();
  const meta = useAppSelector(getEventMeta);

  useEffect(() => {
    dispatch(getEventMetaThunk());
  }, []);

  const handleChooseEvent = (group: any) => {
    const eventId = group.event_id || group.id;
    const status = group.event_id
      ? {
          id: group.id,
          name: group.name,
        }
      : group.default_status
      ? { id: group.default_status.id, name: group.default_status.name }
      : undefined;
    const props: any = {};

    if (mergePerson?.id) {
      props.personId = mergePerson.id;
    }

    props.tmpPerson = mergePerson;

    props.status = {
      ...status,
      event: {
        id: eventId,
      },
    };

    openModal(
      RecordEditModalComponent,
      {
        info: {
          ...props,
        },
        isUnmergeDuplicate,
        isNewCandidate,
        onSaved: onCandidateAdded,
      },
      {
        replace: true,
        disableClose: false,
      },
    );
  };

  const renderContent = () => {
    function asArray(group: EventMetaGroup | EventMetaGroup[]) {
      return Array.isArray(group) ? group : [group];
    }

    return (
      <StyledRecordPreNewStack>
        <StyledRecordPreNewStackV>
          <StyledRecordPreNewStackGroup>
            {meta.items.group1 &&
              asArray(meta.items.group1).map((group: EventMetaGroup) => (
                <ButtonComponent
                  key={uniqueId(`group-${group.id}`)}
                  customColor={group.color}
                  handleClick={() => handleChooseEvent(group)}
                >
                  {group.name}
                </ButtonComponent>
              ))}
          </StyledRecordPreNewStackGroup>
        </StyledRecordPreNewStackV>
        <StyledRecordPreNewStackV>
          <StyledRecordPreNewStackGroup>
            {meta.items.group2 &&
              asArray(meta.items.group2).map((group: EventMetaGroup) => (
                <ButtonComponent
                  key={uniqueId(`group-${group.id}`)}
                  customColor={group.color}
                  handleClick={() => handleChooseEvent(group)}
                >
                  {group.name}
                </ButtonComponent>
              ))}
          </StyledRecordPreNewStackGroup>
          <StyledRecordPreNewStackGroup>
            {meta.items.group3 &&
              asArray(meta.items.group3).map((group: EventMetaGroup) => (
                <ButtonComponent
                  key={uniqueId(`group-${group.id}`)}
                  customColor={group.color}
                  handleClick={() => handleChooseEvent(group)}
                >
                  {group.name}
                </ButtonComponent>
              ))}
          </StyledRecordPreNewStackGroup>
        </StyledRecordPreNewStackV>
        <StyledRecordPreNewStackV>
          <StyledRecordPreNewStackGroup>
            {meta.items.group4 &&
              asArray(meta.items.group4).map((group: EventMetaGroup) => (
                <ButtonComponent
                  key={uniqueId(`group-${group.id}`)}
                  customColor={group.color}
                  handleClick={() => handleChooseEvent(group)}
                >
                  {group.name}
                </ButtonComponent>
              ))}
          </StyledRecordPreNewStackGroup>
          <StyledRecordPreNewStackGroup>
            {meta.items.group5 &&
              asArray(meta.items.group5).map((group: EventMetaGroup) => (
                <ButtonComponent
                  key={uniqueId(`group-${group.id}`)}
                  customColor={group.color}
                  handleClick={() => handleChooseEvent(group)}
                >
                  {group.name}
                </ButtonComponent>
              ))}
          </StyledRecordPreNewStackGroup>
        </StyledRecordPreNewStackV>
      </StyledRecordPreNewStack>
    );
  };

  return (
    <StyledRecordPreNew>
      <BaseModalComponent>
        {!meta.loading ? renderContent() : <SpinnerComponent />}
      </BaseModalComponent>
    </StyledRecordPreNew>
  );
};

export default RecordPreNewModalComponent;
